<div class="d-flex justify-content-between align-items-center">
    <button class="btn btn-primary" data-toggle="modal" data-target="#createNewDocument" (click)="resetNewDocument()">{{ 'Documents.CreateDocument' | translate }}</button>
</div>
<div class="row">
    <!-- OFFERS -->
    <div class="col-12 mt-3" *ngIf="!!statuses && offers && offers.length > 0">
        <div class="card">
            <h4>{{ 'Standard.Offers' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Offers">
                <thead>
                    <th class="pl-1">{{ 'Offers.OfferNumber' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="text-right">{{ 'Standard.SentAt' | translate }}</th>
                    <th class="text-right">{{ 'Offer.AcceptanceDate' | translate }}</th>
                    <th class="text-right">{{ 'Standard.Price' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let o of offers; trackBy:trackById" (click)="route(o, $event)">
                        <td class="pl-1">{{ o.offerNumber }}</td>
                        <td>{{ o.title }}</td>
                        <td>{{ caseActions.statusNameById(o.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="text-right">{{ o.sentAt ? sentAtDate(o.sentAt) : sentAtDate(o.createdAt) }}</td>
                        <td class="text-right">{{ !!o.acceptanceDate ? sentAtDate(o.acceptanceDate) : '' }}</td>
                        <td class="text-right">{{ formatCurrency(o.totalPrice) }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + o.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(o)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(o, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(o.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(o, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(o.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(o, '728eade9-0a48-4b0e-8c8f-20c585c032c0')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(o.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Deselected' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = o;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="o.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    <tr style="background-color: #F0F7FF;">
                        <td colspan="7" class="pl-1 pr-1">
                            <div class="flex-between text-bold">
                                <div class="text-bold">{{ 'Standard.TotalPrice' | translate }}</div>
                                <div>{{ getTotal(offers) }}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- AGREEMENT NOTES -->
    <div class="col-12 mt-3" *ngIf="!!statuses && agreementNotes && agreementNotes.length > 0">
        <div class="card">
            <h4>{{ 'Standard.AgreementNotes' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Agreement notes">
                <thead>
                    <th class="pl-1">{{ 'Offers.OfferNumber' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th class="text-right">{{ 'Standard.Status' | translate }}</th>
                    <th class="text-right">{{ 'Standard.SentAt' | translate }}</th>
                    <th class="text-right">{{ 'Offer.AcceptanceDate' | translate }}</th>
                    <th class="text-right">{{ 'Standard.Price' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let a of agreementNotes; trackBy:trackById" (click)="route(a,$event)">
                        <td class="pl-1">{{ a.offerNumber }}</td>
                        <td>{{ a.title }}</td>
                        <td>{{ caseActions.statusNameById(a.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="text-right">{{ a.sentAt ? sentAtDate(a.sentAt) : '' }}</td>
                        <td class="text-right">{{ a.acceptanceDate ? sentAtDate(a.acceptanceDate) : sentAtDate(a.acceptanceDate) }}</td>
                        <td class="text-right">{{ formatCurrency(a.totalPrice) }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + a.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(a)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(a, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(a.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(a, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(a.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(a, '728eade9-0a48-4b0e-8c8f-20c585c032c0')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(a.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Deselected' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = a;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="a.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    <tr style="background-color: #F0F7FF;">
                        <td colspan="7" class="pl-1 pr-1">
                            <div class="flex-between text-bold">
                                <div class="text-bold">{{ 'Standard.TotalPrice' | translate }}</div>
                                <div>{{ getTotal(agreementNotes) }}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- CONTRACTS -->
    <div class="col-12 mt-3" *ngIf="!!statuses && contracts && contracts.length > 0">
        <div class="card">
            <h4>{{ 'Standard.Contracts' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Contracts">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="text-right">{{ 'Standard.SentAt' | translate }}</th>
                    <th class="text-right">{{ 'Offer.AcceptanceDate' | translate }}</th>
                    <th class="text-right">{{ 'Standard.Price' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of contracts; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="text-right">{{ c.sentAt ? sentAtDate(c.sentAt) : '' }}</td>
                        <td class="text-right">{{ c.acceptanceDate ? sentAtDate(c.acceptanceDate) : sentAtDate(c.acceptanceDate) }}</td>
                        <td class="text-right">{{ formatCurrency(c.totalPrice) }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '728eade9-0a48-4b0e-8c8f-20c585c032c0')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Deselected' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    <tr style="background-color: #F0F7FF;">
                        <td colspan="7" class="pl-1 pr-1">
                            <div class="flex-between text-bold">
                                <div class="text-bold">{{ 'Standard.TotalPrice' | translate }}</div>
                                <div>{{ getTotal(contracts) }}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- SUBCONTRACTOR OFFERS -->
    <div class="col-12 mt-3" *ngIf="!!statuses && subcontractorOffers && subcontractorOffers.length > 0">
        <div class="card">
            <h4>{{ 'Offer.SubcontractorOffer' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Subcontractor offer">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="text-right">{{ 'Standard.SentAt' | translate }}</th>
                    <th class="text-right">{{ 'Offer.AcceptanceDate' | translate }}</th>
                    <th class="text-right">{{ 'Standard.Price' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of subcontractorOffers; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="text-right">{{ c.sentAt ? sentAtDate(c.sentAt) : sentAtDate(c.createdAt) }}</td>
                        <td class="text-right">{{ c.acceptanceDate ? sentAtDate(c.acceptanceDate) : sentAtDate(c.acceptanceDate) }}</td>
                        <td class="text-right">{{ formatCurrency(c.totalPrice) }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '728eade9-0a48-4b0e-8c8f-20c585c032c0')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Deselected' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    <tr style="background-color: #F0F7FF;">
                        <td colspan="7" class="pl-1 pr-1">
                            <div class="flex-between text-bold">
                                <div class="text-bold">{{ 'Standard.TotalPrice' | translate }}</div>
                                <div>{{ getTotal(contracts) }}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- HOUSING ASSESSMENTS -->
    <div class="col-12 mt-3" *ngIf="!!statuses && housingAssesments && housingAssesments.length > 0">
        <div class="card">
            <h4>{{ 'Standard.CooperativeHousingAssessment' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Housing assessments">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of housingAssesments; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- SERVICE CONTRACTS -->
    <div class="col-12 mt-3" *ngIf="!!statuses && serviceContracts && serviceContracts.length > 0">
        <div class="card">
            <h4>{{ 'Standard.ServiceContract' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Service contracts">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of serviceContracts; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '728eade9-0a48-4b0e-8c8f-20c585c032c0')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Deselected' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- MAINTENACE BUDGET -->
    <div class="col-12 mt-3" *ngIf="!!statuses && maintenanceBudget && maintenanceBudget.length > 0">
        <div class="card">
            <h4>{{ 'Document.MaintenanceBudget' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Maintenance budgets">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of maintenanceBudget; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- SUPERVISORY NOTES -->
    <div class="col-12 mt-3" *ngIf="!!statuses && supervisoryNotes && supervisoryNotes.length > 0">
        <div class="card">
            <h4>{{ 'Standard.SupervisoryNotes' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Supervisory notes">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of supervisoryNotes; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- ENERGY REPORT -->
    <div class="col-12 mt-3" *ngIf="!!statuses && energyReports && energyReports.length > 0">
        <div class="card">
            <h4>{{ 'Standard.EnergyReport' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Energy reports">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of energyReports; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c;" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' | translate
                                        }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- MOVE IN OUT -->
    <div class="col-12 mt-3" *ngIf="!!statuses && moveInOut && moveInOut.length > 0">
        <div class="card">
            <h4>{{ 'Document.MoveInOutReports' | translate }}</h4>
            <table *ngIf="!!statuses" aria-label="Move in/out reports">
                <thead>
                    <th class="pl-1">{{ 'Standard.Number' | translate }}</th>
                    <th>{{ 'Standard.Name' | translate }}</th>
                    <th>{{ 'Standard.Status' | translate }}</th>
                    <th class="actionMenuCell"></th>
                </thead>
                <tbody>
                    <tr *ngFor="let c of moveInOut; trackBy:trackById" (click)="route(c,$event)">
                        <td class="pl-1">{{ c.offerNumber }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ caseActions.statusNameById(c.statusId.toLowerCase(), statuses) | translate }}</td>
                        <td class="actionMenuCell">
                            <div class="btn btn-outline-light actionMenuBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon hero-icon-outline">
                                    <path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="actionsMenu" [attr.id]="'actionsMenu-' + c.offerId">
                                <ul class="list-group">
                                    <li class="list-group-item" (click)="documentActions(c)" data-toggle="modal" data-target="#changeStatus">{{ 'Buttons.AcceptReject' | translate }}</li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, 'f833a8c3-2944-4a3d-a9b3-8faa01156485')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','f833a8c3-2944-4a3d-a9b3-8faa01156485','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.New' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="newOfferStatus(c, '8bfc347c-40c4-42ca-93fc-f4d651c0a109')"
                                        *ngIf="!['728eade9-0a48-4b0e-8c8f-20c585c032c0','8bfc347c-40c4-42ca-93fc-f4d651c0a109','bee21fe3-503e-4a8b-8ac4-030929c87741','e65f9d9e-34b2-4423-8ad4-7228db8814b4','a1a453b8-6ae7-453d-bfdb-867ace78654e'].includes(c.statusId)">
                                        {{ 'Buttons.ChangeStatusTo' | translate }} {{ ('Offers.Pipeline' | translate) | lowercase }}
                                    </li>
                                    <li class="list-group-item" (click)="forDeletion = c; tester()" data-toggle="modal" data-target="#deleteDocumentModal" *ngIf="c.statusId != 'a1a453b8-6ae7-453d-bfdb-867ace78654e'">{{ 'Buttons.Delete' |
                                        translate }}</li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Create Document Modal -->
<div id="createNewDocument" class="modal fade">
    <div class="modal-dialog modalSlider">
        <div class="modal-content">
            <div class="modal-header borderless">
                <h3 class="text-black mb-0">
                    {{ 'Buttons.Create' | translate }}
                    {{ newDocument.offerTypeId == '91946653-6667-4f47-97b5-044e5e6b26dd' ? ('Standard.Offer' | translate) :
                    newDocument.offerTypeId == '0fd35664-fe7f-418b-b82d-67e2d2e1189f' ? ('Settings.Contract' | translate) :
                    newDocument.offerTypeId == '9865a758-33e6-41c8-bc04-d1b3ac64f72c' ? ('Standard.AgreementNote' | translate) :
                    newDocument.offerTypeId == '039ee8f9-ad58-4568-bde7-cecb88f869c9' ? ('Asset.ServiceContract' | translate) : ''}}
                </h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-window-close red" aria-hidden="true"></i>
                </button>
            </div>
            <div class="modal-body d-flex flex-column gap-3">
                <div class="d-flex flex-column">
                    <div class="text-small text-muted">{{ 'Documents.DocumentType' | translate }}</div>
                    <select class="form-control" [(ngModel)]="newDocument.offerTypeId" (change)="changeType()" *ngIf="!!modules && modules.length > 0">
                        <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                        <option value="91946653-6667-4f47-97b5-044e5e6b26dd">{{ 'Standard.Offer' | translate }}</option>
                        <option value="9865a758-33e6-41c8-bc04-d1b3ac64f72c">{{ 'Standard.AgreementNote' | translate }}</option>
                        <option value="0fd35664-fe7f-418b-b82d-67e2d2e1189f">{{ 'Settings.Contract' | translate }}</option>
                        <option value="039ee8f9-ad58-4568-bde7-cecb88f869c9" [disabled]="!modules.includes('ServiceContract')">{{ 'Asset.ServiceContract' | translate }}</option>
                    </select>
                </div>
                <div class="d-flex flex-column">
                    <div class="text-small text-muted">{{ 'Standard.Responsible' | translate }}</div>
                    <select class="form-control" [(ngModel)]="newDocument.responsibleId">
                        <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                        <option value="{{ responsible.key }}" *ngFor="let responsible of responsibles">{{ responsible.value }}</option>
                    </select>
                </div>
                <div class="d-flex flex-column" *ngIf="!!channels && !specialDoc">
                    <div class="text-small text-muted">{{ 'Dashboard.CaseChannel' | translate }}</div>
                    <select class="form-control" [(ngModel)]="newDocument.caseChannel">
                        <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                        <option value="{{ channel.id }}" *ngFor="let channel of channels">{{ channel.name }}</option>
                    </select>
                </div>
                <div class="d-flex flex-column" *ngIf="!!stages && !specialDoc">
                    <div class="text-small text-muted">{{ 'Standard.Stage' | translate }}</div>
                    <select class="form-control" [(ngModel)]="newDocument.caseStage">
                        <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                        <option value="{{ stage.id }}" *ngFor="let stage of stages">{{ stage.name }}</option>
                    </select>
                </div>
                <div class="d-flex flex-column" *ngIf="!specialDoc">
                    <div class="text-small text-muted">{{ 'Standard.Title' | translate }}</div>
                    <input type="text" class="form-control" [(ngModel)]="newDocument.title">
                </div>
                <div class="d-flex flex-column" *ngIf="!specialDoc">
                    <div class="text-small text-muted">{{ 'Standard.Description' | translate }}</div>
                    <textarea class="form-control" [(ngModel)]="newDocument.description"></textarea>
                </div>
            </div>
            <div class="modal-footer justify-content-end gap-3 borderless">
                <button class="btn btn-primary" data-dismiss="modal" [disabled]="!newDocument.caseId || !newDocument.offerTypeId" (click)="addNewDocumentToCase()">{{ 'Word.Create' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<!--Accept Offer for Customer-->
<div class="modal fade" id="changeStatus" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header p-3">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'Offer.ActionForCustomer' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="changeStatusCloseBtn"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body p-3" *ngIf="!!acceptReject && !!acceptReject.offer">
                <!-- Accept -->
                <div class="row" *ngIf="!!acceptReject.offer && acceptReject.step == 'accept'">
                    <div class="col-4 mb-2">
                        <label class="mb-0 w-100" for="planDate">{{ 'Standard.Date' | translate }}</label>
                        <div class="input-group" *ngIf="!!companyInfo">
                            <input class="form-control" name="planDate" placeholder="{{ 'Date.SelectDate' | translate }}" bsDatepicker #dp="bsDatepicker" [ngModel]="planDate" [bsConfig]="bsConfig" (bsValueChange)="setPlanDate($event)" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-secondary" *ngIf="planDate" (click)="dp.toggle()">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col mb-2">
                        <label class="mb-0" for="planTime">{{ 'Standard.Time' | translate }}</label>
                        <select class="form-control" [(ngModel)]="planTime" id="planTime">
                            <option *ngFor="let x of dueTimes">{{ x }}</option>
                        </select>
                    </div>
                    <div class="col mb-2">
                        <label class="mb-0" for="planHours">{{ ('Standard.Hours' | translate) | titlecase }}</label>
                        <select class="form-control" [(ngModel)]="planHours" id="planHours">
                            <option *ngFor="let x of durationHours">{{ x }}</option>
                        </select>
                    </div>
                    <div class="col mb-2">
                        <label class="mb-0" for="planMinutes">{{ ('Standard.Minutes' | translate) | titlecase }}</label>
                        <select class="form-control" [(ngModel)]="planMinutes" id="planMinutes">
                            <option *ngFor="let x of durationMinutes">{{ x }}</option>
                        </select>
                    </div>
                    <div class="col-4">
                        <label class="mb-0" for="planFitter">{{ 'Standard.AssignedTo' | translate }}</label>
                        <select [(ngModel)]="planFitter" class="form-control" id="planFitter">
                            <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                            <option *ngFor="let x of companyUsers" [value]="x.userId">{{ x.name }}</option>
                        </select>
                    </div>
                    <div class="col-12 d-none">
                        <label class="mb-0" for="planDescription">{{ 'Standard.Description' | translate }}</label>
                        <input type="text" class="form-control" id="planDescription" [(ngModel)]="planDescription">
                    </div>
                </div>
                <!-- Reject -->
                <div class="row" *ngIf="!!acceptReject.offer && acceptReject.step == 'reject'">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="rejectReasonSelection" class="rejectReasonsSelectionTitle">{{ 'Offers.RejectionChoiceTitle' | translate }}</label>
                            <select id="rejectReasonSelection" class="form-control rejectReasonSelection" [(ngModel)]="rejection.chosen">
                                <option [value]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                                <option value="{{ r.id }}" *ngFor="let r of rejection.reasonList">{{ r.text }}</option>
                            </select>
                        </div>
                        <div class="form-group rejectionInput">
                            <label for="rejectionInputTextarea" class="rejectReasonsSelectionTitle">{{ 'Offers.RejectionReason' | translate }}</label>
                            <textarea id="rejectionInputTextarea" class="form-control rejectionInputTextarea" [(ngModel)]="rejection.message"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-between p-3">
                <button type="button" class="btn btn-outline-secondary" (click)="acceptReject.step = 'start'" *ngIf="acceptReject.step != 'start'">
                    {{ 'Buttons.Back' | translate }}
                </button>
                <button type="button" class="btn btn-outline-danger" (click)="acceptReject.step = 'reject'" *ngIf="acceptReject.offer != null && acceptReject.step == 'accept'">
                    {{ 'Buttons.RejectOffer' | translate }}
                </button>
                <button type="button" class="btn btn-danger" (click)="rejectOffer()" *ngIf="acceptReject.step == 'reject'" [disabled]="rejection.chosen == null || rejection.chosen == 'null' || rejection.message == ''">
                    {{ 'Buttons.RejectOffer' | translate }}
                </button>
                <button type="button" class="btn btn-success" (click)="acceptOffer()" *ngIf="acceptReject.step == 'accept'" [disabled]="acceptBtnDisabled">
                    {{ 'Buttons.AcceptOffer' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteDocumentModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'Buttons.Delete' | translate }} {{ ('Word.Document' | translate) | lowercase }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="modal-body d-flex p-3 justify-content-center align-items-center text-normal">{{ 'Standard.DeleteConfirmation.Text' | translate }}</div>
            <div class="modal-footer justify-content-end gap-3">
                <button class="btn btn-secondary" data-dismiss="modal" (click)="forDeletion = null;">{{ 'Buttons.Close' | translate }}</button>
                <button class="btn btn-danger" data-dismiss="modal" (click)="deleteDocument()">{{ 'Buttons.Delete' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<div id="clearPriceOrderModal" class="modal fade">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header borderless">
                <h5 class="modal-title" id="pendingMessageModalLabel">{{ 'Offers.GoToBasket' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="modal-body" *ngIf="clearPriceStep == 0">
                <div class="rowItem justify-content-between align-items-center" *ngFor="let o of productDocs" (click)="docToClearPrice(o.offerId)">
                    <div>
                        <div class="d-flex gap-3 align-items-center"><span class="badge {{ statusByGuid(o.statusId).color }}">{{ statusByGuid(o.statusId).text | translate }}</span><span># {{ o.offerNumber }}</span></div>
                        <div class="font-weight-bold ellipsis">{{ o.title }}</div>
                        <div class="d-flex align-items-center gap-3">
                            <div class="d-flex gap-1"><span class="text-muted">{{ 'Standard.CostPriceShort' | translate }}:</span><span class="font-weight-bold"> {{ +o.costPrice | number: '1.2-2':'da' }}</span></div>
                            <div class="d-flex gap-1"><span class="text-muted">{{ 'Standard.SalesPriceShort' | translate }}:</span><span class="font-weight-bold"> {{ +o.totalPrice | number: '1.2-2':'da' }}</span></div>
                        </div>
                    </div>
                    <div style="width:2rem;">
                        <input class="form-control" type="radio" [checked]="clearPriceDocuments.includes(o.offerId)" />
                    </div>
                </div>
            </div>
            <div class="modal-body d-flex flex-column gap-3" *ngIf="clearPriceStep == 1">
                <div class="d-flex align-items-center gap-3">
                    <div class="flex-1">{{ 'Cases.CaseNumber' | translate }}</div>
                    <div class="flex-2"><input type="text" [(ngModel)]="clearPriceBasketInfo.orderNumber" class="form-control" autocomplete="off" placeholder="{{ 'Standard.Required' | translate }}"></div>
                </div>
                <div class="d-flex align-items-center gap-3">
                    <div class="flex-1">{{ 'Standard.Name' | translate }}</div>
                    <div class="flex-2">
                        <input type="text" [(ngModel)]="clearPriceBasketInfo.name" class="form-control" autocomplete="off" placeholder="{{ 'Standard.Required' | translate }}">
                    </div>
                </div>
                <div class="d-flex align-items-center gap-3">
                    <div class="flex-1">{{ 'Standard.Address' | translate }}</div>
                    <div class="flex-2">
                        <input type="text" [(ngModel)]="clearPriceBasketInfo.address" class="form-control" autocomplete="off" />
                    </div>
                </div>
                <div class="d-flex align-items-center gap-3">
                    <div class="flex-1">{{ 'Standard.Zipcode' | translate }}</div>
                    <div class="flex-2">
                        <input type="text" [(ngModel)]="clearPriceBasketInfo.zipCode" class="form-control" autocomplete="off" />
                    </div>
                </div>
                <div class="d-flex align-items-center gap-3">
                    <div class="flex-1">{{ 'Standard.City' | translate }}</div>
                    <div class="flex-2">
                        <input type="text" [(ngModel)]="clearPriceBasketInfo.city" class="form-control" autocomplete="off" />
                    </div>
                </div>
            </div>
            <div class="modal-footer borderless justify-content-end">
                <button class="btn btn-secondary" data-dismiss="modal" *ngIf="clearPriceStep == 0">{{ 'Buttons.Close' | translate }}</button>
                <button class="btn btn-secondary" (click)="clearPriceStep = 0" *ngIf="clearPriceStep == 1">{{ 'Buttons.Back' | translate }}</button>
                <button class="btn btn-primary" [disabled]="!clearPriceDocuments.length" (click)="clearPriceStep = 1;" *ngIf="clearPriceStep == 0">{{ 'Buttons.Next' | translate }}</button>
                <button class="btn btn-primary" (click)="addToBasket()" [disabled]="clearPriceBasketInfo.orderNumber == '' || clearPriceBasketInfo.name == ''" data-dismiss="modal" *ngIf="clearPriceStep == 1">{{ 'Offers.GoToBasket' |
                    translate }}</button>
            </div>
        </div>
    </div>
</div>